$(document).on("turbolinks:load", function() {
    $(".selectize").selectize({
        sortField: "text",
      })
})
